import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AddressRiskAssessment from './pages/address-risk-assessment';
import TransactionAnalysis from './pages/transaction-analysis';
import ForensicReportGenerator from './pages/forensic-report-generator';
import InvestigationDashboard from './pages/investigation-dashboard';
import FundFlowMapping from './pages/fund-flow-mapping';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AddressRiskAssessment />} />
        <Route path="/address-risk-assessment" element={<AddressRiskAssessment />} />
        <Route path="/transaction-analysis" element={<TransactionAnalysis />} />
        <Route path="/forensic-report-generator" element={<ForensicReportGenerator />} />
        <Route path="/investigation-dashboard" element={<InvestigationDashboard />} />
        <Route path="/fund-flow-mapping" element={<FundFlowMapping />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
